<template>
  <v-alert
    :color="data.Color"
    dense
    text
    :icon="data.Icon"
    border="left"
    :style="{
      'margin': !isSimulation && isDesktop ? '15px 30px 15px 30px' : '15px' 
    }"
  >
    {{text}}
  </v-alert>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import constants from '@/constants'
  import utils from '@/services/utils'
  export default {
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
    },
    data: () => ({
    }),
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'ColorContent']),
      text () {
        return this.data.AlertText ? utils.getTranslation (this.data.AlertText, this.locale) : ''
      },
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop () {
        return !utils.isMobile()
      }
    },
  }
</script>
